import React from 'react';
import { connect } from 'react-redux';
import MemberHeadForm from './MemberHeadForm';
import MemberForm from './MemberForm';
import { startAddMember } from '../actions/members';
import Pincodes from './pincodes.json'

export class AddMemberPage extends React.Component {
  onSubmit = (member) => {
    this.props.startAddMember(member);
    this.props.history.push('/');
  };
  render() {
    return (
      <div>
      <div className='page-header'>
      <div className='content-container'>
      {this.props.memberCount === 0 ? <h1 className='page-header__title'>Add Head of the Family</h1> : <h1 className='page-header__title'>Add Member</h1>}
      </div>
      </div>
        
       <div className='content-container'>
       {this.props.memberCount === 0 ?
       <MemberHeadForm
       onSubmit={this.onSubmit}
     />:
     <MemberForm
       onSubmit={this.onSubmit}
     />
       }
       </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  startAddMember: (member) => dispatch(startAddMember(member))
});
const mapStateToProps = (state) => {
  const visibleMembers = state.members;

  return {
    memberCount: visibleMembers.length,
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(AddMemberPage);



// WEBPACK FOOTER //
// ./src/components/AddMemberPage.js